// SelectWrapper.tsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select, { Props as SelectProps, SingleValueProps } from 'react-select';
import PeopleIcon from 'assets/icon-user';
import {
  SelectBox,
  selectStyles,
  selectTheme,
  CustomSelectDiv,
  IconBackSelect,
} from './styles'; // Adjust the import path as necessary

interface OptionType {
  label: string | number;
  value: string | number;
}

const CustomSelectValue = (props: SingleValueProps<OptionType>) => (
  <CustomSelectDiv>
    <IconBackSelect className="experience-view__icon-back-select">
      <PeopleIcon data-testid="people-icon" />
    </IconBackSelect>
    {props.data.label}
  </CustomSelectDiv>
);

interface SelectWrapperProps
  extends Omit<SelectProps<OptionType, false>, 'options'> {
  options: OptionType[];
}

const SelectWrapper: React.FC<SelectWrapperProps> = ({ options, ...props }) => {
  const { t: translate } = useTranslation();
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [focusedOptionIndex, setFocusedOptionIndex] = useState<number | null>(
    null,
  );
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (menuIsOpen) {
      if (event.key === 'Tab') {
        event.preventDefault();
        setFocusedOptionIndex((prevIndex) => {
          const nextIndex =
            prevIndex !== null ? (prevIndex + 1) % options.length : 0;
          return nextIndex;
        });
      } else if (event.key === 'Enter' && focusedOptionIndex !== null) {
        event.preventDefault();
        handleSelectOption();
      }
    } else if (event.key === 'Enter') {
      event.preventDefault();
      setMenuIsOpen(true);
    }
  };

  const handleSelectOption = () => {
    setMenuIsOpen(false);
    setFocusedOptionIndex(null);
  };

  return (
    <SelectBox aria-label={translate('selectParticipants')}>
      <Select<OptionType>
        menuIsOpen={menuIsOpen}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
        onKeyDown={handleKeyDown}
        onBlur={() => setMenuIsOpen(false)}
        aria-label={translate('selectParticipants')}
        label="Guests"
        styles={selectStyles}
        theme={selectTheme}
        isSearchable={false}
        options={options}
        {...props}
        components={{
          SingleValue: CustomSelectValue,
        }}
      />
    </SelectBox>
  );
};

export default SelectWrapper;
